import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Footer from './Footer';
import Novedades from './components/Novedades';
import Videos from './components/Videos';
import TodasNovedades from './components/TodasNovedades';
import Contactos from './components/Contactos';
import Presentacion from './components/Presentacion';
import QuienesSomos from './components/QuienesSomos';
import Mision from './components/Mision';
import Funciones from './components/Funciones';
import Autoridades from './components/Autoridades';
import Licitaciones from './components/Licitaciones';
import NoticiaDetalle from './components/NoticiaDetalle';
import PanelNovedades from './components/PanelNovedades';
import Ribera from './components/Ribera';
import SIG from './components/GIS';
import Tramites from './components/Tramites';
import CustomNavbar from './components/common/navbar/CustomNavbar.jsx';
import tramiteCardIcon from './assets/cards/tramites.svg';
import licitacionesCardIcon from './assets/cards/licitaciones.svg';
import gisCardIcon from './assets/cards/gis.svg';

const Inicio = () => {
  const [shouldLoadHeroVideo, setShouldLoadHeroVideo] = useState(false);

  useEffect(() => {
    const elements = document.querySelectorAll('.reveal-on-scroll');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -30px 0px' }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShouldLoadHeroVideo(true);
    }, 150);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <main className="home">
      <section className="hero-section">
        <video
          className="hero-video"
          src={shouldLoadHeroVideo ? require('./Imagenes/videos/DPA WEB.mp4') : undefined}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        />
        <div className="hero-overlay" />
        <div className="hero-content home-container">
          <h1 className="hero-title reveal-on-scroll">
            Desarrollando infraestructura hidráulica para el <span>futuro</span> de nuestra provincia.
          </h1>
          <p className="hero-subtitle reveal-on-scroll">
            Infraestructura hidrica sustentable, proteccion de cuencas y gestion eficiente para el
            crecimiento de nuestra provincia.
          </p>
        </div>
      </section>

      <section className="quick-links-wrapper">
        <div className="home-container quick-links-grid">
          <Link to="/presentacion" className="quick-link-card reveal-on-scroll">
            <span className="quick-link-icon">
              <img src={tramiteCardIcon} alt="Icono Tramites" />
            </span>
            <h3>Tramites</h3>
            <p>Gestion de permisos de riego, vuelcos y certificados hidricos online.</p>
          </Link>

          <Link to="/licitaciones" className="quick-link-card reveal-on-scroll">
            <span className="quick-link-icon">
              <img src={licitacionesCardIcon} alt="Icono Licitaciones" />
            </span>
            <h3>Licitaciones</h3>
            <p>Seguimiento de obras publicas, pliegos y convocatorias vigentes.</p>
          </Link>

          <Link to="/gis" className="quick-link-card reveal-on-scroll">
            <span className="quick-link-icon">
              <img src={gisCardIcon} alt="Icono GIS" />
            </span>
            <h3>SIG</h3>
            <p>Mapas, capas geoespaciales y monitoreo territorial para gestion hidrica.</p>
          </Link>
        </div>
      </section>

      <Novedades />
      <Videos />

      {/* Stats strip oculto temporalmente */}
    </main>
  );
};

const Webmail = () => (
  <div style={{ padding: '4rem 0', textAlign: 'center' }}>
    <a
      href="https://claronet.mail2world.com/app/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        fontSize: '2rem',
        color: '#1976d2',
        fontWeight: 700,
        textDecoration: 'none',
        border: '2px solid #1976d2',
        borderRadius: '8px',
        padding: '1.2rem 2.5rem',
        transition: 'background 0.2s, color 0.2s',
        background: '#f8f9fa',
        marginTop: '2rem'
      }}
      onMouseOver={(e) => {
        e.target.style.background = '#1976d2';
        e.target.style.color = '#fff';
      }}
      onMouseOut={(e) => {
        e.target.style.background = '#f8f9fa';
        e.target.style.color = '#1976d2';
      }}
    >
      Acceder a Webmail
    </a>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const targets = document.querySelectorAll('.reveal-on-scroll:not(.visible)');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -22px 0px' }
    );

    const timer = setTimeout(() => {
      targets.forEach((element) => observer.observe(element));
    }, 30);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/contactos" element={<Contactos />} />
        <Route path="/tramites" element={<Tramites />} />
        <Route path="/presentacion" element={<Presentacion />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/mision" element={<Mision />} />
        <Route path="/funciones" element={<Funciones />} />
        <Route path="/autoridades" element={<Autoridades />} />
        <Route path="/licitaciones" element={<Licitaciones />} />
        <Route path="/ribera" element={<Ribera />} />
        <Route path="/gis" element={<SIG />} />
        <Route path="/webmail" element={<Webmail />} />
        <Route path="/novedades" element={<TodasNovedades />} />
        <Route path="/novedades/:id" element={<NoticiaDetalle />} />
        <Route path="/panel-novedades" element={<PanelNovedades />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
